export const springDefaultConfig = {
  friction: 40,
  tension: 450,
};
